"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![DocumentIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDEyIDE2Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+RG9jdW1lbnQ8L3RpdGxlPgogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPgogICAgPGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj4KICAgICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTIsNC4xOWwwLS4wNmEuNC40LDAsMCwwLS4xMi0uMjNMOC4xLjE1QS40LjQsMCwwLDAsNy44NywwTDcuODEsMEguNUEuNS41LDAsMCwwLDAsLjV2MTVhLjUuNSwwLDAsMCwuNS41aDExYS41LjUsMCwwLDAsLjUtLjVWNC4yNVMxMiw0LjIxLDEyLDQuMTlaTTEsMTVWMUg3LjI1VjQuMjVhLjUuNSwwLDAsMCwuNS41SDExVjE1WiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.DocumentIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 12 16", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M12 4.19v-.06a.4.4 0 0 0-.12-.23L8.1.15A.4.4 0 0 0 7.87 0H.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V4.19zM1 15V1h6.25v3.25a.5.5 0 0 0 .5.5H11V15z" })));
};
//# sourceMappingURL=Icon.Document.js.map